import { Attribute, Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[appPreventAutoComplete]',
})
export class PreventAutoCompleteDirective {
  @HostBinding('attr.autocomplete') auto;
  constructor(@Attribute('autocomplete') autocomplete: string) {
    this.auto = autocomplete || 'off';
  }
}
